import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BopProvider } from './BopContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BopProvider>
      <App />
    </BopProvider>
  </React.StrictMode>
);
